const datos = {
    urlapi: 'http://localhost:4000'  // 'https://tremus.delpasystem.com' // 'http://localhost:4000' //  
}

module.exports = datos